import { MusicalNoteIcon } from '@heroicons/react/24/solid';

import React from 'react';

import LinkChd from '../LinkChd';

type Props = {
  globalCmsButtons: any,
  lang: string,
  podcastListenUrl: string,
}

function ListenPodcastButton({ globalCmsButtons, lang, podcastListenUrl }: Props) {
  const linkTitle = globalCmsButtons['Spotify Listen'][lang].title;

  return (
    <LinkChd
      linkStyles="flex mr-0 md:mr-8 font-semibold tracking-wider text-center uppercase text-chdGreen-light hover:text-chdGreen-hover"
      href={podcastListenUrl}
      wrap
    >
      <MusicalNoteIcon className="mr-1 w-[1rem]" fill="white" />
      <p>{linkTitle}</p>
    </LinkChd>
  );
}

export default ListenPodcastButton;
